module.exports = __webpack_public_path__ + "img/bg-pregunta.80cde322.png";